import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useContext } from 'react';
import throttle from 'lodash/throttle';
import { AuthContext } from '../_auth/AuthContext';
import { ISearchResult } from '../_types/search';
import { SearchLocations } from '../_service/location';
import Typography from '@material-ui/core/Typography';
import { IChangeEventHandler } from '../_types/nav';
import { PolicyObjectTypeOptions } from '../_types/ewpolicy';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";  



  interface Props {
    onChange: IChangeEventHandler<ISearchResult | null>;
    isUniversal: boolean;
    inputWidth?: number;
    small?: boolean;
  };
  
  const LocationSearch: React.FC<Props> = (prop: Props) => {

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
          indentAutocomplete: {
            paddingLeft: '1em'
          }
        }),
    );
    const classes = useStyles();
    const [value, setValue] = React.useState<ISearchResult | null>(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState<ISearchResult[]>([]);
    const [selectEnabled, setSelectEnabled] = React.useState<boolean>(false);

    //const loaded = React.useRef(false);
    const { user, setUser } = useContext(AuthContext);
    const history = useHistory();
    
    function redirectToEquipmentPage() {
      history.push("/locations/equipment");
    }

    /** Throttles the SearchLocation Service which calls out to the api to search on users input */
    const fetch = React.useMemo(
      () =>
        throttle((request: { input: string }, callback: (results: ISearchResult[] | null) => void) => {
          SearchLocations(request.input, (user.role ? user.role : 0)).then((res) => callback(res));
          //(autocompleteService.current as any).getPlacePredictions(request, callback);
        }, 200),
      [user],
    );

    React.useEffect(() => {

      setSelectEnabled(false);
      if (user.currentLocation) {
        let v: ISearchResult = {
          key: [ user.currentLocation.id.toString() ],
          value: user.currentLocation.name
        };

        setValue(v);
      } else {
      setValue(null);
      }

    }, [user]);
  
    /** Watches for changes to user input and relays to fetch to execute search */
    React.useEffect(() => {
      let active = true;
      if (inputValue === '') {
        setOptions(value ? [value] : []);
        return undefined;
      }

      fetch({ input: inputValue }, (results: ISearchResult[] | null) => {
        if (active) {
          let newOptions = [] as ISearchResult[];
  
          if (value) {
            newOptions = [value];
          }
  
          if (results) {
            newOptions = [...newOptions, ...results];
          }

          setOptions(newOptions);
        }
      });
  
      return () => {
        active = false;
      };
    }, [value, inputValue, fetch]);
  
    /**
     * 
     * @param newLocation the new location selected by user
     */
    const changeLocation = (newLocation: ISearchResult | null) => {

      if (newLocation) {
        user.currentLocation = {
          uuid: newLocation.uuid,
          deleted: newLocation.deleted,
          id: +newLocation.key,
          objectType: PolicyObjectTypeOptions.servicelocation,
          displayName: newLocation.value,
          name: newLocation.value,
          removed: newLocation.removed,
          tz_offset: newLocation.tz_offset
        };

        if (newLocation.qr_code) {
          redirectToEquipmentPage()
        } 

      } else {
        user.currentLocation = null;
      }
      setSelectEnabled(false);

      setUser({...user});
    }

    const enableSelect = () => {
      setSelectEnabled(true);
    }

    return (!user.locations || user.locations.length > 1) ?
       ( selectEnabled ? (
        <Autocomplete
          id="google-map-demo"
          size={prop.small? "small" : "medium"}
          style={{ width: prop.inputWidth ?? 300 }}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option.value)}
          filterOptions={(x) => x}
          options={options}
          autoComplete
          includeInputInList
          renderOption={(option) => {
            let equipment_uuid = '';
            if (option.qr_code!==undefined && option.qr_code!==null) {
              equipment_uuid = 'Equipment UUID: ' + option.qr_code;
            } 
            return (
              <>
                <div >
                  {option.value}
                  <div className={classes.indentAutocomplete}>
                    {equipment_uuid}
                  </div>
                </div> 
              </>
            );
          }}
          filterSelectedOptions
          value={value}
          onChange={(event: any, newValue: ISearchResult | null) => {
            prop.onChange(newValue);
            setOptions(newValue ? [newValue, ...options] : options);
            setValue(newValue);
            prop.isUniversal && changeLocation(newValue);
          }}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          renderInput={(params) => (
            <TextField label="Location name or equipment identifier" {...params}  variant="outlined" fullWidth />
          )}/>
        ) : (<div >
              <TextField variant="outlined"
                onClick={enableSelect}
                value={user.currentLocation ? user.currentLocation.name : "All Locations"}
                type="text"
                name="input"
                size={prop.small ? "small" : "medium"}
                InputLabelProps={{ shrink: true }}
                style={{ width: prop.inputWidth ?? 300 }}
              />
            </div>
        )
      ) : ( <Typography >{user.currentLocation?.name}</Typography> );
    

  }
  

  export default LocationSearch;